module.exports = __webpack_public_path__ + "img/caret.06504528.svg";